module.exports = __webpack_public_path__ + "img/superkid-certif.79e79882.svg";